<button class="ba-btn dropdown-toggle" aria-controls="collapse-attachments" type="button" id="fileupload-btn-add"
        [attr.aria-label]="'sendmail.form.upload.add-attachments' | i18next" [attr.aria-expanded]="!isCollapsed"
        [class.collapsed]="isCollapsed" [class.after-test]="true" (click)="toggleCollapse()">
    {{ 'sendmail.form.upload.add-attachments' | i18next }}
</button>

<div class="pt-3 collapse" [class.show]="!isCollapsed" id="collapse-attachments" role="tabpanel">
    <div i18nRerenderOnLanguageChange></div>

    <div class="ba-file-uploader">
        <label for="fileupload-attachments">
            {{ 'sendmail.form.upload.file-upload' | i18next }}
            <span class="sr-only">{{ 'sendmail.form.upload.select-files' | i18next }}</span>
            <span #uploadStatusAlert class="sr-only ba-upload-message" role="alert" aria-live="assertive" aria-atomic="true"></span>
        </label>

        <div class="ba-upload-container">
            <div class="ba-upload-dropzone" [class.dropable]="isDragOver" (drop)="onDrop($event)"
                 id="fileupload-dropzone"
                 [class.disabled]="disabled"
                 (dragover)="onDragOver($event)" (dragleave)="onDragLeave()">
                <span>{{ 'sendmail.form.upload.draw-files' | i18next }}</span>
                <span>{{ 'sendmail.form.upload.or' | i18next }} </span>
                <div class="ba-upload-control ba-btn ba-btn-ghost ba-btn-icon ba-icon-upload"
                     [class.disabled]="disabled">
                    <span aria-hidden="true">{{ 'sendmail.form.upload.select-files' | i18next }}</span>
                    <input type="file" id="fileupload-attachments" name="file" multiple
                           (change)="onFileSelected($event)"/>
                </div>
            </div>

            <ul class="ba-upload-files" id="file-list" [attr.aria-label]="'sendmail.form.upload.uploaded-file-list' | i18next">
                @for (uploadFile of uploadFiles; let i = $index; track i) {
                    <li id="file-{{i}}"
                        [ngClass]="'ba-upload-' + uploadFile.status">
                       <span class="ba-title" id="fileupload-status-{{i}}">
                           <!-- loading -->
                           @if (uploadFile.status === 'loading') {
                               {{ uploadFile.fileName }} {{ fileSizeToMbLabel(uploadFile.size) }}
                           }

                           <!-- error -->
                           @if (uploadFile.status === 'error') {
                               {{ uploadFile.fileName }} {{ fileSizeToMbLabel(uploadFile.size) }}
                               <p class="form-text">{{ uploadFile.errorKey |i18next }}</p>
                           }

                           <!-- success -->
                           @if (uploadFile.status === 'success') {
                               <a href="#" (click)="onOpen(i, $event)"
                                  id="fileupload-btn-file-open-{{i}}">{{ uploadFile.fileName }} {{ fileSizeToMbLabel(uploadFile.size) }}</a>
                           }
                       </span>

                        <button type="button" class="ba-upload-delete" (click)="onRemove(i)"
                                id="fileupload-btn-file-remove-{{i}}"
                                title="{{ 'sendmail.form.upload.delete' | i18next}}"
                                [attr.aria-label]="('sendmail.form.upload.delete-file' | i18next) + ': ' + uploadFile.fileName">
                        </button>

                    </li>
                }
            </ul>
        </div>
    </div>

    <pf-hinweisbox [boxType]="HinweisboxTypeEnum.INFO" boxTitle="{{ 'sendmail.form.upload.hint.title' | i18next}}"
                   boxId="hinweis" headerSize="h3"
                   additionalClasses="my-3">
        <ul>
            <li>{{ 'sendmail.form.upload.hint.pdf' | i18next }}</li>
            <li>{{ 'sendmail.form.upload.hint.size' | i18next }}</li>
            <li>{{ 'sendmail.form.upload.hint.size-diff' | i18next }}</li>
            <li>{{ 'sendmail.form.upload.hint.types' | i18next }}</li>
        </ul>
        <p>
            <pf-link-out name="upload"
                         linkText="{{ 'sendmail.form.upload.instructions' | i18next}}"
                         [link]="uploadInstructions"></pf-link-out>
        </p>
    </pf-hinweisbox>
</div>

@if (uploadFiles.length && !isDragOver) {
    <p class="pt-2" id="fileupload-info">
        {{ uploadFiles.length }} {{ 'sendmail.form.upload.documents-added' |i18next }}
    </p>
}